import createClient, { type ClientOptions } from 'openapi-fetch';
import type { paths } from './schema';

export type { components, operations, paths } from './schema';

/** Same-origin API client: the SPA and the API share one origin (ARCHITECTURE §3.2). */
export function createApiClient(options: ClientOptions = {}) {
	return createClient<paths>({ baseUrl: '', ...options });
}
